import { useEffect } from 'react';

// Installs UserGuiding once per page load using the vendor's own snippet: a small
// stub on window.userGuiding queues calls (identify included) until the SDK has
// loaded, and the SDK replays that queue as it initialises - identify first, then
// anything else once identification completes. So identify() is safe to call the
// moment we know who the user is, with no polling for the SDK to be ready.
//
// The previous loader removed and re-added the <script> every time the user info
// object changed (five times on one page load, each a 4 MB bundle - the SDK warned
// "You are loading UserGuiding SDK multiple times"), and replaced the SDK's own
// window.userGuiding with a Proxy over a shallow copy of it, taken while the SDK
// was still initialising. Guides and the Resource Center only show once
// identification completes, and support traced the missing content to exactly that.
const installUserGuiding = (code) => {
  if (document.querySelector(`script[src*="user-guiding-${code}"]`)) {
    return;
  }

  /* eslint-disable */
  (function (g, u, i, d, e, s) {
    g[e] = g[e] || [];
    var f = u.getElementsByTagName(i)[0];
    var k = u.createElement(i);
    k.async = true;
    k.src = 'https://static.userguiding.com/media/user-guiding-' + s + '-embedded.js';
    f.parentNode.insertBefore(k, f);
    if (g[d]) return;
    var ug = (g[d] = { q: [] });
    ug.c = function (n) {
      return function () {
        ug.q.push([n, arguments]);
      };
    };
    var m = ['previewGuide', 'finishPreview', 'track', 'identify', 'hideChecklist', 'launchChecklist'];
    for (var j = 0; j < m.length; j += 1) {
      ug[m[j]] = ug.c(m[j]);
    }
  })(window, document, 'script', 'userGuiding', 'userGuidingLayer', code);
  /* eslint-enable */
};

const UserGuidingLoader = ({ userInfo }) => {
  const ugCode = process.env.REACT_APP_USER_GUIDING_CODE;

  useEffect(() => {
    if (!ugCode) {
      console.error('UserGuiding code is missing in environment variables!');
      return;
    }
    installUserGuiding(ugCode);
  }, [ugCode]);

  // Keyed on the values themselves, not the userInfo object: that object is
  // replaced on every profile refetch, which must not re-identify the user.
  const userId = userInfo?.id;
  const firstName = userInfo?.first_name || '';
  const lastName = userInfo?.last_name || '';
  const role = userInfo?.account_type || '';
  const email = userInfo?.email || '';

  useEffect(() => {
    if (!ugCode || !userId || !window.userGuiding) {
      return;
    }
    window.userGuiding.identify(String(userId), {
      environment: process.env.REACT_APP_ENVIRONMENT,
      user_id: userId,
      first_name: firstName,
      last_name: lastName,
      role,
      email,
    });
  }, [ugCode, userId, firstName, lastName, role, email]);

  return null;
};

export default UserGuidingLoader;
